const evisa = {
  HISTORY: '{BACKOFFICE_BASE}/v1/history/{user_id}/{type}',
  REJECTION_REASONS: '{BACKOFFICE_BASE}/v1/reject_reasons',
  REQUEST_REJECTON_REASONS: '{BACKOFFICE_BASE}/v1/request/rejection_reasons/{type}/{id}',
  GIOS: '{BACKOFFICE_BASE}/v1/gio_offices',
  FARMER_VISA_REQUESTS:
    /* eslint-disable-next-line max-len */
    '{BACKOFFICE_BASE}/v1/farmer_visa_requests?page={page}&request_id={request_id}&status={status}&created_at={created_at}&created_from={created_from}&created_to={created_to}&source={source}&id_number={id_number}',
};

export default evisa;
